import { render, staticRenderFns } from "./outboundInfo.vue?vue&type=template&id=7715c70e"
import script from "./outboundInfo.vue?vue&type=script&lang=js"
export * from "./outboundInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports